﻿<script setup lang="ts">

    import BoolElement from '@/shared/components/BoolElement.vue';
    import { usePipeClassStore } from '@/stores/pipeClassStore.ts';
    import { PipingClassSizeGenericView } from '@/apps/STID_Pipe/pipingClass.ts';
    import { watch } from 'vue';
    const pipeClassStore = usePipeClassStore();
    const emit = defineEmits<{
        /*
        A new value was picked in the selector
         */
        select: [payload: PipingClassSizeGenericView | null];
        /*
        The selected value in the underlying store was modified
         */
        modified: [payload: PipingClassSizeGenericView | null];
    }>();
    function onPipeClassSizeSelect(newValue: PipingClassSizeGenericView) {
        pipeClassStore.setPipingClassSize(newValue.Id);
        emit('select', newValue);
    }
    watch(() => pipeClassStore.selectedPipingClassSize, (newValue: PipingClassSizeGenericView | null) => {
        emit('modified', newValue);
    });
</script>

<template>
    <b-table
        :key="pipeClassStore.pipingClassSizes.length"
        :selected="pipeClassStore.selectedPipingClassSize"
        height="60vh"
        sticky-header
        hoverable
        striped
        bordered
        :data="pipeClassStore.pipingClassSizes"
        :loading="pipeClassStore.loading.pipingClassSizes"
        :mobile-cards="false"
        @select="onPipeClassSizeSelect">
        <b-table-column
            field="Name"
            label="Line size"
            width="100px"
            sortable>
            <template #default="{ row }">
                {{ row.Name }}
            </template>
        </b-table-column>
        <b-table-column
            v-slot="slotProps"
            sortable
            centered
            field="IsValid"
            label="Valid">
            <bool-element :value="slotProps.row.IsValid" />
        </b-table-column>
        <template #empty>
            <div class="has-text-centered">
                {{ pipeClassStore.selectedPipingClass ? "No sizes" : "No piping class selected" }}
            </div>
        </template>
    </b-table>
</template>

<style scoped>

</style>
